import cx from 'classnames'
import React from 'react'
import { resolveInitialSearchQuery } from '../../reducers/user.js'
import type { AdGroup } from '../../types/ad_group.js'
import { StateIndicator } from '../badge/SmallBadge.jsx'
import { PreservingLink } from '../ui/PreservingLink.js'
import { NameText } from './NameText.js'

interface AdGroupNameProps {
    adGroup: AdGroup
    screenshotMode?: boolean
    showState?: boolean
    fill?: boolean
}

export const AdGroupName = ({
    adGroup,
    screenshotMode,
    showState = true,
    fill,
}: AdGroupNameProps) => {
    const searchQuery = resolveInitialSearchQuery()
    let to = `/ad-groups/${adGroup.ad_group_id}`

    if (searchQuery) {
        to = `${to}?${searchQuery}`
    }

    return (
        <PreservingLink
            className={cx('flex min-w-0 overflow-hidden', fill && 'w-full', {
                blur: screenshotMode,
            })}
            to={to}
            style={{ maxWidth: fill ? undefined : 200 }}
        >
            <NameText
                screenshotMode={screenshotMode}
                title={adGroup.name}
                className={cx('relative flex min-w-0 overflow-hidden', fill && 'w-full')}
            >
                {showState && <StateIndicator value={adGroup.state} top={6} left={0} />}
                <span className="block min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap pl-2.5">
                    {adGroup.name}
                </span>
            </NameText>
        </PreservingLink>
    )
}
